export default "__VITE_ASSET__476724ee__"